import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "overflow-hidden rounded-lg border border-slate-200 bg-white"
};
const _hoisted_2 = {
  class: "border-b border-slate-200 px-4 py-3"
};
const _hoisted_3 = {
  class: "flex flex-wrap items-center justify-between gap-3"
};
const _hoisted_4 = {
  class: "min-w-0"
};
const _hoisted_5 = {
  class: "mt-1 text-sm text-slate-500"
};
const _hoisted_6 = {
  class: "block w-full sm:w-48"
};
const _hoisted_7 = {
  key: 0,
  class: "data-table-empty is-compact"
};
const _hoisted_8 = {
  key: 1,
  class: "overflow-x-auto"
};
const _hoisted_9 = {
  class: "min-w-[720px] w-full divide-y divide-slate-200 text-left text-sm"
};
const _hoisted_10 = {
  class: "divide-y divide-slate-100 bg-white"
};
const _hoisted_11 = {
  class: "max-w-[220px] px-4 py-3"
};
const _hoisted_12 = {
  class: "truncate font-medium text-slate-900"
};
const _hoisted_13 = {
  class: "px-4 py-3 text-right font-medium text-slate-700"
};
const _hoisted_14 = {
  class: "px-4 py-3 text-right font-medium text-slate-700"
};
const _hoisted_15 = {
  class: "px-4 py-3 text-right font-medium text-slate-700"
};
const _hoisted_16 = {
  class: "px-4 py-3 text-right text-slate-700"
};
const _hoisted_17 = {
  class: "px-4 py-3"
};
import { computed, ref } from 'vue';
import { formatInvoiceAmount } from '../utils';
import { ledgerCompanyName, ledgerRemainingAmount, ledgerSplitCount, ledgerStatus, ledgerTargetAmount, ledgerUsedAmount } from '../rules.mjs';
export default {
  __name: 'InvoiceCapacityLedger',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    plan: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const keyword = ref('');
    const filteredItems = computed(() => {
      const text = keyword.value.trim().toLowerCase();
      if (!text) return props.items;
      return props.items.filter(item => ledgerCompanyName(item).toLowerCase().includes(text));
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "容量账本", -1)), _createElementVNode("p", _hoisted_5, _toDisplayString(__props.plan?.planMonth || '-') + " · " + _toDisplayString(filteredItems.value.length) + " / " + _toDisplayString(__props.items.length) + " 个客户 ", 1)]), _createElementVNode("label", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "sr-only"
      }, "搜索客户", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
        type: "search",
        class: "form-input w-full rounded-md border-slate-300 text-sm",
        placeholder: "搜索公司"
      }, null, 512), [[_vModelText, keyword.value, void 0, {
        trim: true
      }]])])])]), filteredItems.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.items.length === 0 ? '暂无容量账本' : '没有匹配的客户'), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("thead", {
        class: "bg-slate-50 text-xs font-semibold uppercase tracking-wide text-slate-500"
      }, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "px-4 py-3"
      }, "公司"), _createElementVNode("th", {
        class: "px-4 py-3 text-right"
      }, "目标额度"), _createElementVNode("th", {
        class: "px-4 py-3 text-right"
      }, "已用额度"), _createElementVNode("th", {
        class: "px-4 py-3 text-right"
      }, "剩余额度"), _createElementVNode("th", {
        class: "px-4 py-3 text-right"
      }, "拆分笔数"), _createElementVNode("th", {
        class: "px-4 py-3"
      }, "状态")])], -1)), _createElementVNode("tbody", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item, index) => {
        return _openBlock(), _createElementBlock("tr", {
          key: item.id || item.customerId || index,
          class: "hover:bg-slate-50"
        }, [_createElementVNode("td", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_unref(ledgerCompanyName)(item)), 1)]), _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatInvoiceAmount)(_unref(ledgerTargetAmount)(item))), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatInvoiceAmount)(_unref(ledgerUsedAmount)(item))), 1), _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatInvoiceAmount)(_unref(ledgerRemainingAmount)(item))), 1), _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(ledgerSplitCount)(item)), 1), _createElementVNode("td", _hoisted_17, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge', _unref(ledgerStatus)(item).className])
        }, _toDisplayString(_unref(ledgerStatus)(item).label), 3), item.errorMessage || item.warningMessage ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(['mt-1 text-xs font-medium', item.errorMessage ? 'text-red-600' : 'text-amber-600'])
        }, _toDisplayString(item.errorMessage || item.warningMessage), 3)) : _createCommentVNode("", true)])]);
      }), 128))])])]))]);
    };
  }
};